import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../../../Box/index.js";
const Divider = ()=>{
    const $ = c(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ jsx(Box, {
                width: "1px",
                height: "16px",
                bgcolor: "stroke.secondary",
                mx: "8"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
export { Divider };
